import { useState, useEffect, useRef, useCallback, useMemo } from "react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-balham.css";
import { AgGridReact } from "ag-grid-react";
import {
  ColumnResizedEvent,
  FilterChangedEvent,
  FilterModifiedEvent,
} from "ag-grid-community";
import "ag-grid-enterprise";
import {
  appColor,
  constants,
  EndPoint,
  headers,
  LocateStatus,
  messages,
} from "../../common/constants";
import type { GridApi } from "ag-grid-community";

import { onGridSizeChanged } from "../AgGrid/grid-util";
import { locateEnquiryWorkbookColDefs } from "../../common/columnLocateEnquiryEdit";
import _, { isUndefined } from "lodash";
import { serviceAPIMapping } from "../../config/service-api-mapping";
import axios from "axios";
import swal from "sweetalert";
import { hasAccess, workBookGridStyle } from "../../common/commonFunctions";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
} from "@mui/material";
import { pageConstant } from "../../config/pageConstant";
import * as XLSX from "xlsx";
import { Icon } from "@iconify/react";
import { validateQuantity } from "../../common/tradeValidations";

interface AgGridProps {
  getGridApi?: any;
  isAdmin?: boolean;
  setSelectedRows: any;
  isDeselectAll?: boolean;
  getBtnRef?: (ref: any) => void;
  insertNewRow:any
  onRefreshLocateKPI?:()=> void
}
const EnquiryGridWorkbook = ({
  getGridApi,
  setSelectedRows,
  isAdmin,
  isDeselectAll,
  insertNewRow,
  onRefreshLocateKPI
}: AgGridProps) => {
  const gridRef = useRef<any>(null);
  const [columnDefs] = useState<any>([...locateEnquiryWorkbookColDefs]);
  const [rowData, setRowData] = useState<any[]>([]);
  const [tickerListMap, setTickerListMap] = useState<any>([]);
  const activeClientShortName = window.localStorage.getItem(
    "activeClientShortName"
  );
  const accountId = window.localStorage.getItem("activeAccountCode");
  const userName = window.localStorage.getItem("username");
  const accessToken = window.localStorage.getItem("refreshtoken");
  const [selectedInquiries, setSelectedInquiries] = useState<any[]>([]);
  let secDataByTicker: any;
  let secDataByCusip: any;
  let secDataBySecName: any;
  let noofselectedInqs: any = 0;
  const [isClearDisable, setIsClearDisable] = useState<boolean>(true);
  const [isInquireDisable, setIsInquireDisable] = useState<boolean>(true);

  // let gridApi: any;
  const [rowsToSkip, setRowsToSkip] = useState<any>([]);
  const [excelFileName, setExcelFileName] = useState("");
  const [showSkippedRowPopup, setShowSkippedRowPopup] = useState(false);
  const quantityErrorLimit = 999999999;
  const [bulkUploadInsertRows, setBulkUploadInsertRows] = useState<any>([]);
  const [isInitialRefresh, setIsInitialRefresh] = useState<boolean>(true);
  const defaultColDef = useMemo<any>(() => {
    return {
      flex: 1,
      sortable: true,
      filter: true,
      floatingFilter: false,
      suppressFilterButton: false,
      editable: true,
      resizable: true,
      headerCheckboxSelectionFilteredOnly: true,
      tooltipComponent: CustomTooltip,
      menuTabs: [constants.FilterMenuTab],
      tooltipShowDelay: 10,
      tooltipMouseTrack: true,
      suppressKeyboardEvent: (params: any) => {
        let isTabKey = params?.event?.key === constants.Tab;
        if (isTabKey) gridRef?.current?.api?.stopEditing();
        return false;
      },
    };
  }, []);
  const [rowsToSubmit, setRowsToSubmit] = useState<any>([]);

  const getUpdatedData = useCallback(async (data: any[]) => {
    await gridRef.current?.api?.applyTransactionAsync({ update: data });
    gridRef.current?.api?.refreshCells();
  }, []);

  useEffect(() => {
    if (isDeselectAll !== undefined) gridRef.current?.api?.deselectAll();
  }, [isDeselectAll]);

  useEffect(() => {
    const hasAcc = hasAccess([
      `${pageConstant?.LOCATE_DASHBOARD}_ADMIN`,
      `${pageConstant?.LOCATE_DASHBOARD}_RW`,
      `${pageConstant?.LOCATE_CLIENT}_ADMIN`,
      `${pageConstant?.LOCATE_CLIENT}_RW`,
    ]);

    if (
      selectedInquiries &&
      _.isArray(selectedInquiries) &&
      !_.isEmpty(selectedInquiries)
    ) {
      const isSave =
        [...selectedInquiries]?.filter(
          (r: any) => r?.status === LocateStatus.Error
        )?.length > 0;
      const blankRowsCount = [...selectedInquiries]?.filter(
        (r: any) => !r?.status || _.isEmpty(r?.status) || isUndefined(r?.status)
      )?.length;

      setIsInquireDisable(
        isSave || !hasAcc || blankRowsCount === selectedInquiries?.length
      );
      const isClear =
        [...selectedInquiries]?.filter(
          (r: any) =>
            r?.status === LocateStatus.New || r?.status === LocateStatus.Error
        )?.length > 0;

      setIsClearDisable(!isClear);
      const withOutEmptyRows = _.filter([...selectedInquiries], (e: any) => {
        return (
          (e?.ticker && e?.ticker?.length > 0) ||
          (e?.secName && e?.secName?.length > 0) ||
          (e?.cusip && e?.cusip?.length > 0)
        );
      });
      const rows = withOutEmptyRows?.map((r: any) => {
        return {
          batch: r?.batch,
          client: activeClientShortName?.trim(),
          date: "",
          filename: "",
          qty_req: r?.request_quantity,
          rate_req: r?.rebate,
          sec_id: r?.ticker,
          sec_id_type: "T",
          sm_id: "",
          updatedtime: "",
          user_id: userName,
          account_id: accountId,
          trading_account_id: "",
          centsPerShare: r?.centpershare,
          comments: r?.comments,
          is_wip: false,
          locate_id: r?.locate_id,
          quantity: r?.request_quantity,
          rate: r?.rebate,
          qnty_fill: r?.approved_quantity,
          qnty_req: r?.request_quantity,
          cpty: isAdmin ? r?.client?.trim() : activeClientShortName?.trim(),
          // accrual: _.isNaN(accrual) ? 0 : accrual,
          bl: 0,
          dtc: 0,
          value: r?.value,

          locate_type: "INQUIRY",
          tickerPrice: r?.price,
          qnty_appr: r?.approved_quantity,
        };
      });

      setRowsToSubmit(rows);
    } else {
      setIsClearDisable(true);
      setIsInquireDisable(true);
      setRowsToSubmit([]);
    }
  }, [selectedInquiries]);

  useEffect(() => {
    if (isInitialRefresh) {
      const rows = addEmptyRowsToGrid(500);
      setRowData((previousRows: any) => {
        return [...previousRows, ...rows];
      });
      getTickerList();
      setIsInitialRefresh(false);
    }
  }, []);

  const addEmptyRowsToGrid = (noOfRows: number = 100) => {
    const rows: any[] = [];
    for (let index = 0; index < noOfRows; index++) {
      rows.push({ id: makeid(6) });
    }

    return rows;
    // setRowData((previousRows: any)=>{
    //   return [...previousRows, ...rows]
    // });
  };

  /**
   * Executes whenever Grid/Table filter modifies - this is more sensitive
   * @param params
   */
  const onFilterModified = (params: FilterModifiedEvent) => {
    const { api, columnApi } = params;
  };

  /**
   * Executes whenever Grid/Table filter changes
   * @param params
   */
  const onFilterChanged = (params: FilterChangedEvent) => {
    const { api, columnApi } = params;
    api.deselectAll();
  };

  const autoGroupColumnDef = useMemo(() => {
    return {
      minWidth: 100,
      maxWidth: 200,
    };
  }, []);

  const getRowId = (params: any) => {
    if (params && params.data) {
      if (params.data.inquiry_id) {
        return params.data.inquiry_id;
      } else if (params.data.id) {
        return params.data.id;
      }
    }
    return makeid(5);
  };

  function makeid(length: any) {
    let result = "";
    const characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    const charactersLength = characters.length;
    let counter = 0;
    while (counter < length) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
      counter += 1;
    }
    return result;
  }

  const sideBar = useMemo(() => {
    return {
      toolPanels: [
        {
          id: "columns",
          labelDefault: "Columns",
          labelKey: "columns",
          iconKey: "columns",
          toolPanel: "agColumnsToolPanel",
          toolPanelParams: {
            suppressRowGroups: true,
            suppressValues: true,
            suppressPivots: true,
            suppressPivotMode: true,
            suppressColumnFilter: false,
            suppressColumnSelectAll: false,
            suppressColumnExpandAll: true,
          },
        },
      ],
      defaultToolPanel: "",
    };
  }, []);

  function isForceRefreshSelected() {
    return (document.querySelector("#forceRefresh") as HTMLInputElement)
      ?.checked;
  }
  //   useEffect(() => {
  //     let refreshParams: any = {
  //       force: true,
  //       suppressFlash: true,
  //     };
  //     gridRef?.current!.api?.refreshCells(refreshParams);
  //   }, [globalSearch]);
  // const [setGridApi] = useState<any>(null);
  const [gridApi, setGridApi] = useState<any>(null); // ✅ correct

  const [columnApi, setColumnApi] = useState<any>(null);

  const onGridReady = (params: any) => {
    const api = params.api;
    const columnApi = params.columnApi;

    setGridApi(api);
    setColumnApi(columnApi);

    if (getGridApi) getGridApi(api, columnApi);
    // if (getBtnRef) getBtnRef(gridRef);
  };

  function isSuppressFlashSelected() {
    return (document.querySelector("#suppressFlash") as HTMLInputElement)
      ?.checked;
  }
  const onGridRowDataChanged = (params: any) => {
    let refreshParams: any = {
      force: isForceRefreshSelected(),
      suppressFlash: isSuppressFlashSelected(),
    };
    gridRef.current!.api.refreshCells(refreshParams);
  };
const onCellValueChanged = useCallback((event: any) => {
  let updateArray: any = [];
  setRowData((previousRows: any) => {
    const currentRows = previousRows;
    let index = currentRows?.findIndex((x: any) => x?.id === event.data?.id);
    if (index >= 0) {
      currentRows[index] = event.data;

      switch (event?.column?.colId) {
        case "ticker":
          if (
            event.data?.ticker &&
            event.data?.ticker?.trim() &&
            event.data?.ticker?.length > 0
          ) {
            event.data.ticker = event.data?.ticker?.toUpperCase()

            if (secDataByTicker) {
              const ticker = secDataByTicker?.get(
                event.data?.ticker?.trim()?.toUpperCase()
              );
              if (ticker) {
                currentRows[index].ticker = ticker?.ticker;
                currentRows[index].secName = ticker?.name;
                currentRows[index].cusip = ticker?.cusip;
                currentRows[index].price = ticker?.price;
                currentRows[index].cpty = ticker?.Client || activeClientShortName?.trim(); 
                currentRows[index].username = ticker?.user || userName;                   
                updateArray.push(currentRows[index]);
                if (noofselectedInqs > 0) setIsInquireDisable(false);
              } else {
                currentRows[index].status = "Error";
                currentRows[index].errorCode = "Invalid Ticker";
                currentRows[index].ticker = null;
                currentRows[index].secName = null;
                currentRows[index].cusip = null;
                currentRows[index].price = null;
                updateArray.push(currentRows[index]);
                return [...currentRows];
              }
            }
          } else {
            currentRows[index].ticker = null;
            currentRows[index].secName = null;
            currentRows[index].cusip = null;
            currentRows[index].price = null;
            currentRows[index].status = "Error";
            currentRows[index].errorCode = "Invalid Ticker";
            updateArray.push(currentRows[index]);
            return [...currentRows];
          }
          break;

        case "cusip":
          if (
            event.data?.cusip &&
            event.data?.cusip?.trim() &&
            event.data?.cusip?.length > 0
          ) {
            if (secDataByCusip) {
              const ticker = secDataByCusip?.get(
                event.data?.cusip?.trim()?.toUpperCase()
              );
              if (ticker) {
                currentRows[index].ticker = ticker?.ticker;
                currentRows[index].secName = ticker?.name;
                currentRows[index].cusip = ticker?.cusip;
                currentRows[index].price = ticker?.price;
                currentRows[index].cpty = ticker?.Client || activeClientShortName?.trim();
                currentRows[index].username = ticker?.user || userName;                    
                updateArray.push(currentRows[index]);
              } else {
                currentRows[index].status = "Error";
                currentRows[index].errorCode = "Invalid Ticker";
                currentRows[index].ticker = null;
                currentRows[index].secName = null;
                currentRows[index].cusip = null;
                currentRows[index].price = null;
                updateArray.push(currentRows[index]);
                return [...currentRows];
              }
            }
          } else {
            currentRows[index].ticker = null;
            currentRows[index].secName = null;
            currentRows[index].cusip = null;
            currentRows[index].price = null;
            currentRows[index].status = "Error";
            currentRows[index].errorCode = "Invalid Ticker";
            updateArray.push(currentRows[index]);
            return [...currentRows];
          }
          break;

        case "secName":
          if (
            event.data?.secName &&
            event.data?.secName?.trim() &&
            event.data?.secName?.length > 0
          ) {
            if (secDataBySecName) {
              const ticker = secDataBySecName?.get(
                event.data?.secName?.trim()?.toUpperCase()
              );
              if (ticker) {
                currentRows[index].ticker = ticker?.ticker;
                currentRows[index].secName = ticker?.name;
                currentRows[index].cpty = ticker?.Client || activeClientShortName?.trim(); 
                currentRows[index].username = ticker?.user || userName;   
                currentRows[index].cusip = ticker?.cusip;
                currentRows[index].price = ticker?.price;
                                 
                updateArray.push(currentRows[index]);
              } else {
                currentRows[index].status = "Error";
                currentRows[index].errorCode = "Invalid Ticker";
                currentRows[index].ticker = null;
                currentRows[index].secName = null;
                currentRows[index].cusip = null;
                currentRows[index].price = null;
                updateArray.push(currentRows[index]);
                return [...currentRows];
              }
            }
          } else {
            currentRows[index].ticker = null;
            currentRows[index].secName = null;
            currentRows[index].cusip = null;
            currentRows[index].price = null;
            currentRows[index].status = "Error";
            currentRows[index].errorCode = "Invalid Ticker";
            updateArray.push(currentRows[index]);
            return [...currentRows];
          }
          break;
      }

      if (
        isNaN(event.data?.request_quantity) ||
        event.data?.request_quantity < 0 ||
        !validateQuantity(currentRows[index].request_quantity)
      ) {
        currentRows[index].request_quantity = 0;
        updateArray.push(currentRows[index]);
      }

      currentRows[index].status = "New";
      currentRows[index].errorCode = "";
      currentRows[index].isSelectable = true;
      getAvailableQtyOnCellChange(currentRows[index]);
      updateArray.push(currentRows[index]);
    }

    return [...currentRows];
  });

  const nextRowIndex = event?.rowIndex + 1;
  if (
    gridRef?.current &&
    gridRef?.current?.api &&
    gridRef?.current?.columnApi
  ) {
    const rowCount = gridRef?.current?.api?.getDisplayedRowCount();
    if (nextRowIndex < rowCount) {
      gridRef?.current?.api?.setFocusedCell(nextRowIndex, "ticker");
      gridRef?.current?.api?.startEditingCell({
        rowIndex: nextRowIndex,
        colKey: "ticker",
      });
    }
  }

  const onGridReady = (params: any) => {
    setGridApi(params.api);
    setColumnApi(params.columnApi);
  };

  var params = {
    force: true,
    suppressFlash: true,
    columns: ["isSelect"],
  };

  gridApi?.refreshCells(params);
}, []);

  useEffect(() => {
    if (gridApi) {
      gridApi?.applyTransaction({ update: rowData });

      var params = {
        force: true,
        suppressFlash: true,
      };

      gridApi?.refreshCells(params);
    }
  }, [rowData]);

  const isRowSelectable = useMemo(() => {
    return (rowNode: any) => {
      return true;
    };
  }, []);

  const getTickerList = async () => {
    try {
      const options: any = [];

      let getTickerTextFieldRes: any = "";
      const raw = JSON.stringify({
        pageNumber: 0,
        pageSize: 0,
      });
      getTickerTextFieldRes = await axios.post(
        `${serviceAPIMapping["SECMASTER-SERVICE"].apiRouteURL}${EndPoint.secMaster}?account_id=${accountId}`,
        raw,
        { headers: headers }
      );
      if (!getTickerTextFieldRes) {
        // setOpen(true)
        // settickerSnackbarMessage(messages.TickerDownMessage)
      } else if (getTickerTextFieldRes.status === 200) {
        const tickerdataApi: any = getTickerTextFieldRes.data;
        for (let i = 0; i < tickerdataApi.length; i++) {
          const tempOptions: any = {
            value: tickerdataApi[i].ticker + "/" + tickerdataApi[i].cusip,
            label: tickerdataApi[i].name,
            ticker: tickerdataApi[i].ticker,
            cusip: tickerdataApi[i].cusip,
            name: tickerdataApi[i].name,
            price: tickerdataApi[i].price,
            sm_id: tickerdataApi[i].sm_id,
            isin: tickerdataApi[i].isin,
            cins: tickerdataApi[i].cins,
            date: tickerdataApi[i].date,
            updatedTime: tickerdataApi[i].updatedTime,
          };
          options.push(tempOptions);
        }
        secDataByTicker = new Map(
          options.map((t: any) => [t.ticker.toUpperCase(), t])
        );
        setTickerListMap(
          new Map(options.map((t: any) => [t.ticker.toUpperCase(), t]))
        );

        secDataByCusip = new Map(options.map((t: any) => [t.cusip, t]));

        secDataBySecName = new Map(
          options.map((t: any) => [t.name?.toUpperCase(), t])
        );
      } else if (getTickerTextFieldRes.status === 401) {
        //logout(channel)
      }
    } catch (err) {
      console.log("error", err);
    }
  };

  const onSaveEnquiry = async (request: any, rowId: any) => {
    try {
      let endpoint = EndPoint.saveQuoteInquiry;
      axios.defaults.headers.common = {
        Authorization: `Bearer ${accessToken}`,
      };
      await axios
        .post(
          `${serviceAPIMapping["LOCATEMANAGEMENT-SERVICE"].apiRouteURL}${endpoint}`,
          JSON.stringify(request),
          {
            headers: headers,
          }
        )
        .then((response: any) => {
          if (response && response?.status === 200) {
            if (response?.hasError) {
              swal({
                icon: "error",
                text: `Submit Inquiry is failed with response status - ${response?.status} and error ${response?.error}`,
                dangerMode: false,
                closeOnClickOutside: false,
              });
            } else {
              if (!_.isUndefined(response?.data?.responseEntity)) {
                  insertNewRow?.(response?.data?.responseEntity);
                }
              setRowData((previousRows: any) => {
                const currentRows = previousRows;
                let index = currentRows?.findIndex((x: any) => x?.id === rowId);
                if (index >= 0) {
                  currentRows[index] = response?.data?.responseEntity[0];
                  if (
                    response?.data?.responseEntity[0]?.status !== "Error" &&
                    response?.data?.responseEntity[0]?.status !== "New" &&
                    !response?.data?.responseEntity[0]?.is_wip
                  ) {
                    currentRows[index] = { id: rowId };
                  } else {
                    currentRows[index] = {
                      id: rowId,
                      ...response?.data?.responseEntity[0],
                    };
                  }
                }

                return [...currentRows];
              });
            }
          } else {
            swal({
              icon: "error",
              text: `Submit inquiry is failed with response status - ${response?.status} and error ${response?.error}`,
              dangerMode: false,
              closeOnClickOutside: false,
            });
          }
        });
    } catch (error) {
      swal({
        icon: "error",
        text: `Submit inquiry is failed with error ${error}`,
        dangerMode: false,
        closeOnClickOutside: false,
      });
    } finally {
    }
  };

  const onSelectionChanged = useCallback((params: any) => {
    const selectedRs = gridRef.current!.api.getSelectedRows();
    noofselectedInqs = selectedRs.length;
    setSelectedInquiries(selectedRs);
    setSelectedRows(selectedRs);
  }, []);

  const onWorkbookClear = () => {
    onClear();
    setRowData((previousRows: any) => {
      const currentRows = [...previousRows];
      selectedInquiries?.forEach((wip: any) => {
        const wipRowIndex = previousRows?.findIndex(
          (r: any) => r?.id === wip?.id
        );
        if (wipRowIndex !== -1) {
          currentRows[wipRowIndex] = { id: wip?.id };
        }
      });
      gridRef?.current?.api?.deselectAll();

      return currentRows;
    });
  };

  const bulkUploadLocates = async (rowsToUpload: any) => {
    if (rowsToUpload && rowsToUpload?.length > 0) {
      try {
        const request = {
          isInquiry: true,
          isValidate: false,
          isSubmit: true,
          isPreborrow: false,
          locate_src: "UI",
          inquiryRequest: rowsToUpload,
        };

        let endpoint = EndPoint.saveQuoteInquiry;

        axios.defaults.headers.common = {
          Authorization: `Bearer ${accessToken}`,
        };

        await axios
          .post(
            `${serviceAPIMapping["LOCATEMANAGEMENT-SERVICE"].apiRouteURL}${endpoint}`,
            JSON.stringify(request),
            {
              headers: headers,
            }
          )
          .then((response) => {
            if (response && response?.status === 200) {
               if (!_.isUndefined(response?.data?.responseEntity)) {
                  insertNewRow?.(response?.data?.responseEntity);
                }
              gridRef?.current?.api?.deselectAll();
              onWorkbookClear();
              onRefreshLocateKPI?.()
            }
          });
      } catch (error: any) {
        swal({
          icon: "error",
          text: `Submit locate is failed with response status - ${error?.response?.status} error - ${error?.message}`,
          dangerMode: false,
          closeOnClickOutside: false,
        });
      } finally {
      }
    }
  };
  const onColumnResized = useCallback((params: ColumnResizedEvent) => {
    // Do something, e.g., log or save column sizes
  }, []);

  const makeRequest = (
    method: string,
    url: string,
    success: (data: any) => void,
    error: (error: any) => void
  ) => {
    const httpRequest = new XMLHttpRequest();
    httpRequest.open("GET", url, true);
    httpRequest.responseType = "arraybuffer";

    httpRequest.open(method, url);
    httpRequest.onload = function () {
      success(httpRequest.response);
    };
    httpRequest.onerror = function () {
      error(httpRequest.response);
    };
    httpRequest.send();
  };

  const onUploadExcel = (e: any) => {
    makeRequest(
      "GET",
      `${URL.createObjectURL(e.target.files[0])}`,
      function (data) {
        const workbook = convertDataToWorkbook(data);
        populateGrid(workbook, e.target.files[0].name);
      },
      function (error) {
        //turning the flag false, so it can represents that the uploading process has been stoped.
        throw error;
      }
    );
  };

  const convertDataToWorkbook = (dataRows: any) => {
    const data = new Uint8Array(dataRows);
    const arr = [];
    for (let i = 0; i !== data.length; ++i) {
      arr[i] = String.fromCharCode(data[i]);
    }
    const bstr = arr.join("");

    return XLSX.read(bstr, { type: "binary" });
  };

  const onClear = () => {
    setExcelFileName("");
    noofselectedInqs = 0;
  };

  const populateGrid = async (workbook: XLSX.WorkBook, name: any) => {
    // setExcelLoader(true);
    const tempArray: any = [];
    let tempObj: any = {};
    const rowsToSkip: any = [];
    const firstSheetName = workbook.SheetNames[0];
    const worksheet = workbook.Sheets[firstSheetName];
    const columns: Record<string, string> = {
      A: "ticker",
      B: "share",
    };

    if (worksheet["A1"].v === columns.A) {
      setExcelFileName(name);
      let rowIndex = 2;
      if (worksheet["A" + rowIndex] === undefined) {
        const obj = {
          h: "",
          r: "<t>'</t>",
          t: "s",
          v: "",
          w: "",
        };
        worksheet["A" + rowIndex] = obj;
      }
      const expceFileRows: any =
        XLSX.utils.sheet_to_json(worksheet, { blankrows: false, defval: "" })
          .length + 1;
      try {
        while (expceFileRows >= rowIndex) {
          const row: any = {};
          const workRowA =
            worksheet["A" + rowIndex] === undefined
              ? ""
              : worksheet["A" + rowIndex].v;
          if (workRowA !== "#") {
            Object.keys(columns).forEach((column) => {
              row[columns[column]] = worksheet[column + rowIndex]?.w;
            });

            row.status = constants.UI_STATUS_NEW;

            const ticker = tickerListMap?.get(
              row?.ticker?.trim()?.toUpperCase()
            );
            if (
              _.isUndefined(ticker) ||
              _.isUndefined(row.ticker) ||
              _.isNull(row.ticker) ||
              (_.isString(row.ticker) && _.isEmpty(row.ticker?.trim()))
            ) {
              row.status = constants.Error;
              row.rejected_error_reasons = messages.InvalidTicker;
              // rowsToSkip.push(rowIndex);
            } else {
              row.ticker = ticker?.ticker;
              row.secName = ticker?.name;
              row.cusip = ticker?.cusip;
              row.price = ticker?.price;
            }

            if (
              row.share &&
              (isNaN(row.share) ||
                row.share < 0 ||
                row.share > quantityErrorLimit)
            ) {
              //  row.status = constants.Error;
              row.share = 0;
              //  row.rejected_error_reasons = messages.InvalidQuantity;
              //  rowsToSkip.push(rowIndex);
            }

            if (
              (_.isUndefined(ticker) ||
                _.isUndefined(row.ticker) ||
                _.isNull(row.ticker) ||
                (_.isString(row.ticker) && _.isEmpty(row.ticker?.trim()))) &&
              (!row.share ||
                isNaN(row.share) ||
                row.share <= 0 ||
                row.share > quantityErrorLimit)
            ) {
              rowsToSkip.push(rowIndex);
            }

           if (row.status === constants.UI_STATUS_NEW) {
  tempObj = {
    ticker: row?.ticker,
    quantity: row?.share,
    id: makeid(6),
    status: row?.status,
    errorCode: row?.errorCode,
    secName: ticker?.name,
    cusip: ticker?.cusip,
    price: ticker?.price,
    cpty: ticker?.Client || activeClientShortName?.trim(), 
    username: ticker?.user || userName,                    
  };
  tempArray.push(tempObj);
}

          }

          rowIndex++;
        }
      } catch (error) {
        console.log("error", error);
      } finally {
        // setExcelLoader(false);
        if (rowsToSkip?.length > 0) {
          const uniqueRowIndex = _.uniq(rowsToSkip);
          setRowsToSkip(uniqueRowIndex);
          setShowSkippedRowPopup(true);
        }

        if (tempArray?.length > 0) {
          await getAvailableQtyOnBulkUpload(tempArray).then((response: any) => {
            const enqs = tempArray?.map((enq: any) => {
              const tResult = response?.find(
                (e: any) =>
                  e?.ticker.trim()?.toUpperCase() ===
                  enq?.ticker?.trim()?.toUpperCase()
              );
              if (tResult && tResult?.quantity > 0) {
                return {
                  ...enq,
                  response_quantity: tResult?.quantity,
                };
              } else {
                return {
                  ...enq,
                  response_quantity: tResult?.quantity,
                  status: LocateStatus?.Error,
                  errorCode:
                    enq?.secName?.length > 0
                      ? "Quantity Not Available"
                      : "Ticker Not Available",
                };
              }
            });

            setRowData((previousRows: any) => {
              const currentRows = [...previousRows];
              const emptyrows = currentRows?.filter(
                (e: any) =>
                  (!e?.ticker ||
                    _.isEmpty(e?.ticker) ||
                    _.isUndefined(e?.ticker) ||
                    _.isNull(e?.ticker)) &&
                  (!e?.secName ||
                    _.isEmpty(e?.secName) ||
                    _.isUndefined(e?.secName) ||
                    _.isNull(e?.secName)) &&
                  (!e?.cusip ||
                    _.isEmpty(e?.cusip) ||
                    _.isUndefined(e?.cusip) ||
                    _.isNull(e?.cusip))
              );
              if (emptyrows?.length < enqs?.length) {
                const withOutEmptyRows = _.filter(
                  [...previousRows],
                  (e: any) => {
                    return (
                      (e?.ticker && e?.ticker?.length > 0) ||
                      (e?.secName && e?.secName?.length > 0) ||
                      (e?.cusip && e?.cusip?.length > 0)
                    );
                  }
                );
                return [...enqs, ...withOutEmptyRows];
              } else {
                return [...enqs, ...previousRows];
              }
            });
          });

          // const results = await Promise.all(
          //   tempArray.map(async (enq: any) => {
          //     const quantity = await getAvailableQtyOnBulkUpload(enq);
          //     if (quantity > 0) {
          //       return { ...enq, response_quantity: quantity };
          //     } else {
          //       return {
          //         ...enq,
          //         response_quantity: quantity,
          //         status: LocateStatus?.Error,
          //         errorCode:
          //           enq?.secName?.length > 0
          //             ? "Quantity Not Available"
          //             : "Ticker Not Available",
          //       };
          //     }
          //   })
          // );
          // setRowData((previousRows: any) => {
          //   return [...results, ...previousRows];
          // });
        }
      }
    } else {
      // setExcelLoader(false);
      // setApiExceptionHandler({ isError: true, error: messages.TemplateMessage })
    }
  };

  const getAvailableQtyOnCellChange = async (obj: any) => {
    const token = window.localStorage.getItem("refreshtoken");

    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };
    const request = {
      ticker: obj?.ticker,
      quantity: obj?.request_quantity,
    };
    try {
      // const response =
      await axios
        .post(
          `${serviceAPIMapping["LOCATEMANAGEMENT-SERVICE"].apiRouteURL}${EndPoint.getAvailableQuantity}`,
          [request],
          {
            headers: headers,
          }
        )
        .then((response: any) => {
          setRowData((previousRows: any) => {
            const currentRows = previousRows;
            let index = currentRows?.findIndex((x: any) => x?.id === obj?.id);
            if (index >= 0) {
              if (response?.data[0]?.error_text === "Valid Ticker" || response?.data[0]?.error_text === "Partial quantity available" || response?.data[0]?.error_text === "Quantity available" || response?.data[0]?.error_text === null) {
                currentRows[index].response_quantity =
                  response?.data[0]?.quantity;
              } else {
                currentRows[index].response_quantity =
                  response?.data[0]?.quantity;
                currentRows[index].errorCode = response?.data[0]?.error_text;
                obj.status = LocateStatus.Error;
              }
            }

            return [...currentRows];
          });
        });

      // const data = await response;

      // return data;
    } catch (error) {
      // return null;
    }
  };

  const getAvailableQtyOnBulkUpload = async (request: any) => {
    const token = window.localStorage.getItem("refreshtoken");

    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };

    const response = await axios.post(
      `${serviceAPIMapping["LOCATEMANAGEMENT-SERVICE"].apiRouteURL}${EndPoint.getAvailableQuantity}`,
      request,
      {
        headers: headers,
      }
    );

    const res: any = await response;
    return res?.data;
  };

  useEffect(() => {
    if (bulkUploadInsertRows && !_.isEmpty(bulkUploadInsertRows)) {
      setRowData((previousRows: any) => {
        const currentRows = previousRows;

        return [...bulkUploadInsertRows, ...currentRows];
      });
    }
  }, [bulkUploadInsertRows]);

  return (
    <div
      className="ag-theme-balham"
      style={{
        width: "100%",
        height: "99.9%",
      }}
    >
      <div className="d-flex flex-row justify-content-between">
        <Typography
          style={{
            height: "2%",
            paddingLeft: "0.2rem",
            paddingTop: "0.3rem",
            paddingBottom: "0.3rem",
          }}
          className="d-flex flex-row justify-content-start"
        >
          Workbook
        </Typography>
        <div className="d-flex flex-row justify-content-end">
          <div className="upload-btn-main-div d-flex flex-row align-items-center">
            {excelFileName === "" ? (
              <button
                className="excel-upload-btn float-end mb-1 mt-1 mx-2"
                style={{ height: "1.5rem" }}
              >
                <input
                  type="file"
                  className="FileUpload"
                  onChange={onUploadExcel}
                  accept=".xlsx,.xlsm,.xlsb,.xltx,.xltm,.xlt,.xls,.xls"
                />
                <div className="dropZoneOverlay align-items-center">
                  <Icon
                    style={{
                      color: "#1E355E",
                      marginBottom: "0.1rem",
                      marginRight: "0.5rem",
                      height: "1.21rem",
                      width: "1.25rem",
                    }}
                    icon="material-symbols-light:add-circle"
                  />
                  Upload File
                </div>
              </button>
            ) : (
              <div className="me-1" style={{ fontSize: "0.8rem" }}>
                {excelFileName}
                {excelFileName === "" ? (
                  ""
                ) : (
                  <Icon
                    className="cursor-pointer"
                    onClick={onClear}
                    style={{
                      color: "#E90909",
                      height: "0.9rem",
                      cursor: "pointer",
                      marginLeft: "5px",
                    }}
                    icon="material-symbols-light:cancel"
                  />
                )}
              </div>
            )}
            <div className="mt-1 ">
              <a
                href="/locates-workbook-template.xlsx"
                download
                className="float-end me-0 text-nowrap icon-cursor-pointer"
                title={"Download black template"}
              >
                <Icon
                  style={{
                    color: "#1E355E",
                    marginBottom: "0.1rem",
                    marginRight: "0.5rem",
                    height: "1.4rem",
                    width: "1.4rem",
                    cursor: "pointer",
                  }}
                  icon={"tdesign:file-download"}
                ></Icon>
              </a>
            </div>
          </div>

          <Button
            variant="outlined"
            color="error"
            size="small"
            className={`me-2 mt-1 ${
              isClearDisable ? "locate-grid-icon-disable" : ""
            }`}
            onClick={onWorkbookClear}
            sx={{
              cursor: `${
                isClearDisable ? "not-allowed !important" : "pointer"
              }`,
              height: "25px",
            }}
            disabled={isClearDisable}
          >
            Clear
          </Button>

          <button
            onClick={() => bulkUploadLocates(rowsToSubmit)}
            className={`metrics-btn mx-2 p-2 mt-1 d-flex align-items-center icon-cursor-pointer btn btn-primary`}
            disabled={isInquireDisable}
            style={{ height: "25px" }}
          >
            Save As Inquiry
          </button>
        </div>
      </div>
      <AgGridReact
        ref={gridRef}
        rowStyle={{
          justifyContent: "center",
          color: "#2D2D2D",
          fontSize: "0.75rem",
          fontWeight: "400",
          fontStyle: "normal",
        }}
        rowHeight={22}
        headerHeight={26}
        columnDefs={columnDefs}
        getRowId={getRowId}
        onRowDataUpdated={onGridRowDataChanged}
        rowData={rowData}
        suppressRowClickSelection={true}
        defaultColDef={defaultColDef}
        suppressAggFuncInHeader={true}
        enableCellChangeFlash={false}
        animateRows={false}
        enableRangeSelection={true}
        onGridReady={onGridReady}
        onFilterModified={onFilterModified}
        onFilterChanged={onFilterChanged}
        onGridSizeChanged={onGridSizeChanged}
        onColumnResized={onColumnResized}
        rowSelection={"multiple"}
        autoGroupColumnDef={autoGroupColumnDef}
        groupSelectsChildren={true}
        groupSelectsFiltered={true}
        sideBar={sideBar}
        pivotMode={false}
        cacheQuickFilter={false}
        overlayLoadingTemplate={
          '<span class="ag-overlay-loading-center">Please wait while your rows are loading</span>'
        }
        getRowStyle={workBookGridStyle}
        onCellValueChanged={onCellValueChanged}
        isRowSelectable={isRowSelectable}
        onSelectionChanged={onSelectionChanged}
        suppressLastEmptyLineOnPaste={true}
      ></AgGridReact>

      <Dialog
        open={showSkippedRowPopup}
        onClose={(event: any, reason: any) => {
          if (
            reason &&
            (reason == "backdropClick" || reason == "escapeKeyDown")
          ) {
            return;
          }
          setShowSkippedRowPopup(false);
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="rows-skipped"
        maxWidth={"md"}
      >
        <DialogTitle id="alert-dialog-title" sx={{ backgroundColor: appColor }}>
          <Typography sx={{ color: "white" }}>Warning</Typography>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="rows-skipped">
            <div>
              <div>
                These rows were skipped:{" "}
                {rowsToSkip.length > 0 ? _.join(rowsToSkip, ",") : rowsToSkip}
              </div>
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions className="dialog-actions-dense">
          <button
            className="metrics-btn p-2 h-65 d-flex align-items-center btn btn-primary"
            onClick={() => {
              setShowSkippedRowPopup(false);
              setRowsToSkip([]);
            }}
          >
            Close
          </button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

function CustomTooltip() {}
CustomTooltip.prototype.init = function (params: any) {
  var type = params.type || "primary";
  var data = params.api.getDisplayedRowAtIndex(params.rowIndex).data;
  var eGui = (this.eGui = document.createElement("div"));
  eGui.classList.add("custom-tooltip");
  this.eGui.innerHTML =
    '<div class="panel panel-' +
    type +
    '">' +
    '<div class="panel-heading">' +
    '<h3 class="panel-title">' +
    data.country +
    "</h3>" +
    "</div>" +
    '<div class="panel-body">' +
    '<h4 style="white-space: nowrap;">' +
    data.athlete +
    "</h4>" +
    "<p>Total: " +
    data.total +
    "</p>" +
    "</div>" +
    "</div>";
};
CustomTooltip.prototype.getGui = function () {
  return this.eGui;
};
export default EnquiryGridWorkbook;
